import React from 'react';
import ShowLocalNumber from '../ShowLocalNumber'
import LoadingFrame from '../LoadingFrame'
import {Link} from 'react-router-dom'
import CommesseDetailSelect from '../commesse/CommessaSelectDetail'
import MovimentoEntrUsc from './MovimentoEntrUsc'
import MovimentoPrevDef from './MovimentoPrevDef'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'
import ModalConfirm from '../ModalConfirm'

const MovimentoDetail =  ({ loading, movimento, onClickDelete, readonly }) => {

    if (movimento === undefined || movimento.idMovimento === undefined) return <LoadingFrame visible={loading}/>
    let it = movimento;

    let btnEdit= null;
    let btnDelete= null;
    if(readonly){
        btnEdit= (<Link to={"/app/movimenti/edit/" + it.idMovimento} className="ui tiny primary button"><i
                            className="edit icon"/>Modifica</Link>);
        btnDelete= (
            <ModalConfirm
                msg={"Stai per cancellare il movimento: " + it.idMovimento + " del " + it.data}
                onClickOk={(ev) => (onClickDelete(ev, it))}
            >
                <a className="ui tiny red button"><i className="trash icon"/>Elimina</a>
            </ModalConfirm>
        );
    }

    return <div className="ui cards">
        <div className="ui card">
            <div className="content">
                <div className="header">
                    <MovimentoEntrUsc tipo={it.entrUsc} />
                    &nbsp;<MovimentoPrevDef tipo={it.prevDef}/>&nbsp;<LocalDate data={it.data} />

                </div>
                <div className="description">
                    <p></p>
                </div>
                <div className="header">
                    <p>{it.idPdc.nomeCompleto}</p>
                </div>
                <div className="description">
                    <p>{it.causale}</p>
                </div>
                <div className="description">
                    <p>{it.forma}</p>
                </div>
                <div className="description">
                    <p></p>
                </div>
                <div className="description">
                    <p>{it.soggetto}</p>
                </div>
            </div>
            <div className="content">
                <div className="ui vertical basic segment">
                    <label>Anno di competenza</label>
                    <label className="ui label right floated">{it.annoComp}</label>
                </div>
                <div className="ui vertical basic segment">
                    <label>Estratto conto</label>
                    <label className="ui label right floated">{it.estrConto ? it.estrConto : 'Non specificato'}</label>
                </div>
                <div className="ui vertical basic segment">
                    <label>Corrispettivo</label>
                    <label className="ui label right floated">
                        <ShowLocalNumber value={it.corrispettivo}/></label>
                </div>
                <div className="ui vertical basic segment">
                    <label>Pagamento</label>
                    <label className="ui label right floated">
                        <ShowLocalNumber value={it.pagamento}/></label>
                </div>
            </div>
            <div className="content">
                <div className="ui vertical basic segment">
                    Creato il {it.creatoIl ?  <b><LocalDate data={it.creatoIl } /> <LocalTime data={it.creatoIl } /></b> : <b>?</b>} da <b>{it.creatoDa ? it.creatoDa.username : '?'}</b>
                </div>
                <div className="ui vertical basic segment">
                    <p>Modificato il {it.modificatoIl ?  <b><LocalDate data={it.modificatoIl } /> <LocalTime data={it.modificatoIl } /></b> : <b>?</b>} da <b>{it.modificatoDa ? it.modificatoDa.username : '?'}</b></p>
                </div>
            </div>
            <div className="extra content">
                <div className="ui grid">
                    <div className="center aligned five wide column">
                        <Link to={"/app/movimenti"} className="ui tiny primary button"><i
                            className="table icon"/>Elenco</Link>
                    </div>
                    <div className="center aligned five wide column">
                        {btnEdit}
                    </div>
                    <div className="center aligned five wide column">
                        {btnDelete}
                    </div>
                </div>
            </div>

        </div>
        {
            it.idCommessa ? <CommesseDetailSelect loading={loading} commessa={it.idCommessa} /> : <div></div>
        }
    </div>
};

export default MovimentoDetail;


/** WEBPACK FOOTER **
 ** ./src/components/movimenti/MovimentoDetail.js
 **/